import React from "react";
import { Routes, Route } from "react-router-dom";
import ClientsList from "./ClientsList";
import ClientDetailPage from "./ClientDetailPage";
import ClientDuplicatesPage from "./merge/ClientDuplicatesPage";
import ClientMergeWizard from "./merge/ClientMergeWizard";

/**
 * Nested routes under /admin/clients/*
 */
export default function ClientsRoutes() {
  return (
    <Routes>
      <Route index element={<ClientsList />} />
      <Route path="duplicates" element={<ClientDuplicatesPage />} />
      <Route path="merge" element={<ClientMergeWizard />} />
      <Route path=":clientId" element={<ClientDetailPage />} />
    </Routes>
  );
}
